import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Order, Language } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const SourceCellContent: React.FC<SourceCellContent.Props> = ({
	item,
	language,
}) => {
	const { t } = useTranslation();

	const content = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isLanguageMatched =
			item?.cellsForTableSettings?.lang === language;

		const preparedCell = item?.cellsForTable?.[ColumnId.Source];

		if (
			isCellsReady &&
			isLanguageMatched &&
			preparedCell != null
		) {
			return preparedCell;
		}

		return cellProcessing(item.source, t);
	}, [
		item?.cellsForTable,
		item?.cellsForTableSettings?.isCellsReady,
		item?.cellsForTableSettings?.lang,
		item.source,
		language,
		t,
	]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace SourceCellContent {
	interface Props {
		item: Order.Model;
		language: Language;
	}
}

export default SourceCellContent;
